<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import TmpApi from '@/services/api/tmp.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Anejo 15 - Informe de Altas',
      routes: ['Informes', 'Anejo 15 - Informe de Altas'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          regions: [],
          centers: [],
          providers: [],
          specialists: [],
        },
        filters: {
          academicYear: null,
          region: null,
          center: null,
          provider: null,
          specialist: null,
          sie: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          clearable: false,
          class: 'col-md-3',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          clearable: true,
          class: 'col-md-6',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          disabled:
            this.model.search.collections.providers.length <= 0 ||
            this.model.search.collections.providers.length == 1,
          onChanged: this.onChangeProvider,
        },
        {
          name: 'region',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Región',
          placeholder: 'Seleccionar',
          clearable: true,
          class: 'col-md-3',
          options: this.model.search.collections.regions,
          value: this.model.search.filters.region,
          disabled: this.model.search.collections.regions.length <= 0,
          onChanged: this.onChangeRegion,
        },
        {
          name: 'center',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Centro',
          placeholder: 'Seleccionar',
          clearable: true,
          class: 'col-md-3',
          options: this.model.search.collections.centers,
          value: this.model.search.filters.center,
          disabled: this.model.search.collections.centers.length <= 0,
          onChanged: this.onChangeCenter,
        },

        {
          name: 'specialist',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Especialista',
          placeholder: 'Seleccionar',
          clearable: true,
          class: 'col-md-6',
          options: this.model.search.collections.specialists,
          value: this.model.search.filters.specialist,
          disabled:
            this.model.search.collections.specialists.length <= 0 ||
            this.model.search.collections.specialists.length == 1,
        },
        {
          name: 'sie',
          component: 'CustomInput',
          type: 'text',
          label: 'SIE',
          placeholder: 'Escriba número de SIE',
          icon: 'fa fa-search orange-icon',
          class: 'col-md-3',
          leftIcon: true,
          value: this.model.search.filters.sie,
          disabled: this.model.search.filters.sieDisabled,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getCurrentYearAcademicYears().then((res) => {
        this.model.search.collections.academicYears = res.data

        if (res.data.length > 0) {
          this.model.search.filters.academicYear = res.data[0]
          this.onChangeAcademicYear()
        }
      })
    },
    async onChangeAcademicYear() {
      this.model.search.filters.region = null
      this.model.search.collections.regions = []
      this.model.search.filters.center = null
      this.model.search.collections.centers = []
      this.model.search.filters.provider = null
      this.model.search.collections.providers = []
      this.model.search.filters.specialist = null
      this.model.search.collections.specialists = []

      await this.getProvider()
    },
    async onChangeRegion() {
      this.model.search.filters.center = null
      this.model.search.collections.centers = []
      this.model.search.filters.specialist = null
      this.model.search.collections.specialists = []

      if (this.model.search.filters.region !== null) await this.getCenter()
    },
    async onChangeCenter() {
      this.model.search.filters.specialist = null
      this.model.search.collections.specialists = []

      if (this.model.search.filters.center !== null) await this.getSpecialist()
    },
    async onChangeProvider() {
      this.model.search.filters.region = null
      this.model.search.collections.regions = []
      this.model.search.filters.center = null
      this.model.search.collections.centers = []
      this.model.search.filters.specialist = null
      this.model.search.collections.specialists = []

      await this.getRegion()
    },
    async getRegion() {
      await TmpApi.getRegionByAcademicYear({
        anejoNum: 15,
        academicYearId: this.model.search.filters.academicYear?.id,
        companyId: this.model.search.filters.provider?.id,
      }).then((res) => {
        this.model.search.collections.regions = res.data
      })
    },
    async getCenter() {
      await TmpApi.getCenters({
        anejoNum: 15,
        academicYearId: this.model.search.filters.academicYear?.id,
        regionId: this.model.search.filters.region?.id,
        companyId: this.model.search.filters.provider?.id,
      }).then((res) => {
        this.model.search.collections.centers = res.data
        if (res.data.length == 1) {
          this.model.search.filters.center = res.data[0]
          this.getSpecialist()
        }
      })
    },
    async getProvider() {
      let res = await TmpApi.getProvider({
        anejoNum: 15,
        academicYearId: this.model.search.filters.academicYear?.id,
      });

      this.model.search.collections.providers = res.data;

      if (res.data.length == 1) {
        this.model.search.filters.provider = res.data[0];
        await this.getRegion();
        await this.getSpecialist();
      }
    },
    async getSpecialist() {
      await TmpApi.getSpecialist({
        anejoNum: 15,
        academicYearId: this.model.search.filters.academicYear?.id,
        regionId: this.model.search.filters.region?.id,
        centerId: this.model.search.filters.center?.id,
        companyId: this.model.search.filters.provider?.id,
      }).then((res) => {
        this.model.search.collections.specialists = res.data

        if (res.data.length == 1) {
          this.model.search.filters.specialist = res.data[0]
        }
      })
    },
    async onHandlerSearch() {
      this.process()
    },
    async process() {
      await ReportServices.getReport('anejo15admissiondropdetail', {
        academicYearId: this.model.search.filters.academicYear.id,
        regionId: this.model.search.filters.region?.id,
        centerId: this.model.search.filters.center?.id,
        companyId: this.model.search.filters.provider?.id,
        specialistId: this.model.search.filters.specialist?.id,
        studentSieId: this.model.search.filters.sie,
      }).then((res) => DocumentServices.Download(res.data))
    },
  },
}
</script>
